
export { default as page404 } from "./pages/msg.svelte";
export { default as page500 } from "./pages/msg.svelte";

/**
 *
 */

interface Route {
    path: string,
    load: () => Promise<any>,
    params?: Object,
}

//页面
export const routes: Array<Route> = [
    {
        path: "/",
        load: () => import('./pages/index.svelte'),
    },
    {
        path: "/about",
        load: () => import('./pages/about.svelte'),
    },
    {
        path: "/100026",
        load: () => import('./pages/xz.svelte'),
    },
    {
        path: "/100027",
        load: () => import('./pages/xz.svelte'),
    },
    {
        path: "/100040",
        load: () => import('./pages/xz.svelte'),
    },
    {
        path: "/huodong/2022/gangfengzhengweng",
        load: () => import('./pages/huodong/2022/gangfengzhengweng.svelte'),
    },
    {
        path: "/huodong/2022/abo",
        load: () => import('./pages/huodong/2022/abo.svelte'),
    },
    {
        path: "/huodong/2022/aidraw",
        load: () => import('./pages/huodong/2022/aidraw.svelte'),
    },
    {
        path: "/huodong/2023/shuangshuang",
        load: () => import('./pages/huodong/2023/shuangshuang.svelte'),
    },
    {
        path: "/huodong/2023/wxshare",
        load: () => import('./pages/huodong/2023/wxshare.svelte'),
    },
];

//只在服务器端运行的api
export const apis: Array<Route> = [
];

